import { Box, BoxProps } from '@chakra-ui/react'
import { useWindowScroll, useWindowSize } from 'react-use'
import * as React from 'react'

import { FixedCopy, FixedDate, FixedLogo } from '../icons'
import { useResponsive } from '../../hooks/useResponsive'
import { vw } from '../../styles/theme'
import SVG from '../common/SVG'

export type OverlayProps = BoxProps & {}

const Overlay: React.FC<OverlayProps> = ({ ...others }) => {
  const footerHeight = useResponsive(0, 570)
  const [marginBottom, setMarginBottom] = React.useState(0)
  const [minHeightPc, setMinHeightPc] = React.useState('100vh')

  const { y } = useWindowScroll()
  const { height } = useWindowSize()
  React.useEffect(() => {
    const contentHeight = document
      ? Math.max.apply(undefined, [
          document.body.clientHeight,
          document.body.scrollHeight,
          document.documentElement.scrollHeight,
          document.documentElement.clientHeight,
        ])
      : undefined

    if (contentHeight) {
      const db = contentHeight - y - height - footerHeight
      const mb = contentHeight === height ? 0 : Math.max(0, -db)
      setMarginBottom(mb)

      if (mb === 0) {
        setMinHeightPc('850px')
      } else {
        setMinHeightPc('auto')
      }
    }
  }, [y, height])

  return (
    <>
      <Box
        pos="fixed"
        top="0"
        bottom={marginBottom}
        left="0"
        right="0"
        minW={['contentMinWSP', 'contentMinWPC']}
        minH={['auto', minHeightPc]}
        css={{
          pointerEvents: 'none',
        }}
        {...others}
      >
        <SVG svg={<FixedCopy />} w={[vw(450), '317px']} pos="absolute" right="0" top="0" />
        <SVG svg={<FixedDate />} w={[vw(53), '53px']} pos="absolute" right="0" bottom="0" />
        <SVG svg={<FixedLogo />} w={[vw(345), '435px']} pos="absolute" left="0" bottom="0" />
      </Box>
    </>
  )
}

export default Overlay
